import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { FormComponentProps } from 'antd/lib/form';
import { Row, Col, message, Form, Modal, Icon } from 'antd';
import * as videoResourceAction from '../../redux/action/video-resource.action';
// import Alert from '../../components/Alert/Alert';
import ResourceAttachmentItem from './resource-attachment-item';
import ResourceViewCom from '../../components/media/resourceView/resourceView';
import {
  NormalObj,
  mergeProps,
  getSearchParams,
  getUserId,
  formatUrl,
  uuid,
  MyIcon,
  getExtensionType,
} from '../../util';
import Footer from '../../components/Footer';
// import { PlayTime } from '../../util/playTime';
import './index.less';
import 'video-marker-player/dist/index.css';
import withHiddenLabel from '../../components/withHiddenLabel';
import AxiosWrap from '../../lib/request';
import { getClassRecordResources, getPrepareLessonResources } from './util';
import { BasicResourceItem, FollowSubResourceType } from './types';
import { VideoResourceType, videoResourceTypes } from '../other-resource-list/types';
import apiConfig from '../../config/api';
import { sortBy } from 'lodash';
import TrackRequest from '../../lib/trackRequest';

interface P extends RouteComponentProps, FormComponentProps {
  file_no_exist: Boolean;
  courseInfo: NormalObj;
  lessonList: NormalObj[];
  commentResult: NormalObj;
  scoreDetail: NormalObj;
  functionConfig: NormalObj;
  hiddenLabel: boolean; // 由 HOC 注入
}
class Vod extends Component<P, any> {
  appId: string;
  pause: boolean;
  topRef: any;
  bottomRef: any;
  media: any;
  xgPlayer: any;
  bottomMedia: any;
  searchParams: NormalObj;
  nextCourse: NormalObj;
  playerPrevStatus: string;
  private randomMd5: string;
  /**
   * topTx 顶部腾讯播放器播放
   * topH5 顶部H5播放器播放
   * bottomTx 底部腾讯播放器播放
   * bottomH5 底部H5播放器播放
   */
  private videoStatus: 'topTx' | 'topH5' | 'bottomTx' | 'bottomH5' | null = null;

  constructor(props: P) {
    super(props);
    this.appId = '';
    this.bottomRef = null;
    this.media = null;
    this.bottomMedia = null;
    this.pause = false;
    this.resize = this.resize.bind(this);
    this.topRef = null;
    this.searchParams = getSearchParams(props.location.search);
    this.nextCourse = {};
    this.playerPrevStatus = '';
    this.randomMd5 = uuid();
    this.state = {
      number: 0,
      showPreview: false,
      videoHeight: window.innerHeight - 116,
      preViewProps: {
        url: '',
        type: '',
      },
      activeTimeIndex: '',
      activeLessonIndex: '',
      resourceInfo: {
        // 可是详情
        centerResources: [],
        materialChapters: [],
      },
      openTitle: false,
      showResourceList: true,
    };
    this.pausePlayer = this.pausePlayer.bind(this);
  }
  componentDidMount() {
    // 将页面置顶
    window.scrollTo(0, 0);
    this.screenChange();
    this.initData();
    window.addEventListener('visibilitychange', this.onStopVideo);
  }

  componentWillUnmount() {
    // this.PlayTimeFn.clearStatus();
    window.removeEventListener('resize', this.resize);
    // topPlayer && topPlayer.dispose();
    // bottomPlayer && bottomPlayer.dispose();
    // topPlayer = null;
    // bottomPlayer = null;
    // Alert.remove('lesson');
    // Alert.remove('lessonList');
    window.removeEventListener('visibilitychange', this.onStopVideo);
  }

  // 暂停播放
  onStopVideo = (): void => {
    if (document.visibilityState === 'hidden') {
      this.pausePlayer();
    }
  };

  // 初始化数据获取
  initData = async () => {
    // 获取课时详情
    const { videoResourceType, resourceId } = this.searchParams;
    const isClassRecord = String(videoResourceType) === String(VideoResourceType.CLASS_RECORD);
    const { data: resourceInfo } = await AxiosWrap({
      url: isClassRecord
        ? `/temporary-resources/prepare-lesson-packages/${resourceId}`
        : `/warehouse/api/basic-resource/unperson/${resourceId}?version=1.0`,
      baseURL: isClassRecord ? apiConfig.api : apiConfig.gateway,
      ...(isClassRecord
        ? {}
        : {
            params: {
              userCenterRoleCode: 'Teacher',
              userId: getUserId(),
            },
            noUserId: true,
            noLeagueId: true,
          }),
    } as any);

    const { file_no_exist, location } = this.props;
    this.searchParams = getSearchParams(location.search);
    const resources = isClassRecord
      ? getClassRecordResources(resourceInfo)
      : getPrepareLessonResources(resourceInfo);

    const { idx, mainVideo, centerResources } = this.filterData(resources, file_no_exist);
    resourceInfo.centerResources = centerResources;
    const id = this.getMainId(mainVideo, idx);

    if (
      centerResources &&
      centerResources.length > 0 &&
      centerResources.every((item: NormalObj) => this.isSupportType(item.extension, true))
    ) {
      this.setState({ noSupport: true });
    }
    this.setState(
      {
        resourceInfo,
      },
      () => {
        centerResources[idx] && this.playLesson(id, idx, centerResources[idx], true);
      },
    );
  };
  // 获取课堂实录视频id
  getClassRecordVideoId(classRecordInfo: any): string | null {
    let id = null;
    if (classRecordInfo && Array.isArray(classRecordInfo.files)) {
      classRecordInfo.files.forEach((file: any) => {
        if (file.extension.toLowerCase() === 'mp4') {
          id = file.fileId;
        }
      });
    }
    return id;
  }
  // 获取视频
  /**
   * 预览默认视频----默认预览第一个可预览视频
   * @param id 课时Id
   * @param index 课时序号
   * @param updateMainVideoInfo 是否更新点播视频信息
   */
  playLesson = async (
    id: string,
    index: number,
    item: any,
    updateMainVideoInfo: boolean,
    openDirect?: boolean,
  ) => {
    let data: NormalObj = {};
    const { applyStartTime } = this.state.resourceInfo;
    const { category, resourceId, extension, fileName, fileId } = item;

    TrackRequest({
      name: 'alternative-resource_information',
      data: {
        file_name: fileName,
        file_type: extension,
        file_id: fileId,
        prepare_lesson_package_id: this.searchParams.resourceId,
        timestamp_start: Date.now(),
        timestamp_end: '',
        resource_id: resourceId,
        column_id: this.searchParams.columnId,
        prepare_lesson_apply_time: applyStartTime,
      },
    });

    // ResourceCategory.普通试卷 = 6，pdf不支持预览
    // 因为是绝密资料
    if (category === 6 && extension.toLowerCase() === 'pdf') {
      message.error('暂不支持预览！', 1);
      data = { fileId: '', url: '', marks: [] };
    } else {
      data = await videoResourceAction.filePreview(
        id,
        encodeURIComponent(item.fileName),
        resourceId,
      );
    }
    if (updateMainVideoInfo && item.category === 1) {
    }
    this.setState({
      showPreview: true,
      preViewProps: {
        url: formatUrl(data, this.randomMd5),
        type: getExtensionType(data.extension),
      },
    });
    // }
    this.setState({
      activeLessonIndex: id + index,
    });
  };
  /**
   * 是否支持预览格式
   * @param type 资源后缀
   * @param isSupport 支持所有/一个都不支持
   */
  isSupportType(type: string, isSupport?: Boolean | undefined) {
    const supportType = [
      'ppt',
      'pptx',
      'jpg',
      'png',
      'mp3',
      'wma',
      'wav',
      'mp4',
      'swf',
      'xls',
      'xlsx',
      'doc',
      'docx',
      'pdf',
    ];
    if (!isSupport) {
      return supportType.indexOf(type.toLowerCase()) > -1;
    } else {
      return supportType.indexOf(type.toLowerCase()) === -1;
    }
  }

  /**
   * 获取主视频ID
   * @param data 课堂实录/支持预览的附件
   */
  getMainId(data: NormalObj | null, index: any) {
    return data && data.fileId;
  }
  screenChange() {
    window.addEventListener('resize', this.resize);
  }
  resize() {
    this.setState({ videoHeight: window.innerHeight - 180 });
  }
  /**
   * 资源预览
   * @param id 附件id
   * @param extension 资源后缀
   * @param index 选中附件序号
   */
  previewClick = async (item: any, index: number) => {
    // this.PlayTimeFn.stopPlayTime();
    const { fileId: id, extension } = item;
    if (this.isSupportType(extension, true)) {
      message.error('暂不支持预览！', 1);
      return;
    }

    if (this.state.activeLessonIndex === id + index) return;
    if (
      ['mp3', 'mp4'].indexOf(getExtensionType(extension)) > -1 &&
      (this.videoStatus === 'bottomH5' || this.videoStatus === 'bottomTx')
    ) {
      this.pausePlayer();
    } else if (this.videoStatus === 'topH5' || this.videoStatus === 'topTx') {
      this.videoStatus = null;
    }
    this.playLesson(id, index, item, false);
  };

  /**
   * 过滤数据
   * @param data 数据源
   * @param file_no_exist 文件不存在 // todo
   */
  filterData(data: BasicResourceItem[], file_no_exist?: Boolean) {
    let idx = 0;
    let result: NormalObj[] = [];
    const fileIds = new Set<string>();
    let mainVideo: NormalObj | null = null;
    if (data && data.length > 0) {
      const _result: NormalObj[] = [];
      for (let i = 0, len = data.length; i < len; i++) {
        const item = data[i];
        item.files.forEach((_item: NormalObj) => {
          if (fileIds.has(_item.fileId)) {
            return;
          }
          fileIds.add(_item.fileId);
          _item.category = item.category;
          _item.resourceGuid = item.resourceGuid;
          _item.resourceType = item.resourceType;
          _item.resourceId = item.id;
          _result.push(_item);
        });
      }
      // 需要排序的资源类型,课件类型的mp4排在前面。这里只有课堂资料类型
      const sortResourceTypes: FollowSubResourceType[] = [
        FollowSubResourceType.CourseMemoir,
        FollowSubResourceType.Courseware,
        FollowSubResourceType.Material,
      ];
      // sortBy 默认升序，false(0) 在前，true(1) 在后. mp4 在最前面
      result = sortBy(_result, [
        (item) =>
          sortResourceTypes.includes(item.resourceType.code) &&
          (item.extension || '').toLowerCase() !== 'mp4',
      ]);
      mainVideo = result[0];
      if (file_no_exist) {
        idx = result.findIndex((item: NormalObj) => this.isSupportType(item.extension));
        if (idx > -1) mainVideo = result[idx];
      }
    }

    return { idx, mainVideo, centerResources: result };
  }

  /**
   * 暂停上/下播放器
   */
  pausePlayer() {
    switch (this.videoStatus) {
      // case 'topTx':
      //   topPlayer.pause();
      //   break;
      case 'topH5':
        this.xgPlayer?.pause();
        this.media?.pause();
        break;
      // case 'bottomTx':
      //   bottomPlayer.pause();
      //   break;
      case 'bottomH5':
        this.bottomMedia?.pause();
        break;
      default:
    }
    this.videoStatus = null;
  }

  /**
   * 设置顶部资源中心播放器组件
   * @param media 播放器实例  --- 2022/2/16 新增需求：MP3格式的附件也需要统计观看时长
   */
  handleMedia(media: any) {
    this.media = media;
    this.media.on('play', () => {
      this.videoStatus !== 'topH5' && this.pausePlayer();
      this.videoStatus = 'topH5';
    });
    this.media.on('ended', () => {
      if (this.media.isFullscreen_) {
        this.media.exitFullscreen();
      }
    });
    this.media.on('pause', () => {});
    this.media.on('timeupdate', () => {});

    // 播放速率更改
    this.media.on('ratechange', () => {});
    // 播放报错
    this.media.on('error', () => {
      // console.log('播放报错了', this.media.error_);
      const { error_ } = this.media;
      if (error_ && error_.code === 3) {
        Modal.info({
          title: '观看出错啦，请重新打开浏览器再试！',
          okText: '知道了',
          onOk() {},
        });
      }
    });
  }

  /**
   * 计算议课评分 的宽度
   * @param n 分数
   */
  calcWidth(n: number) {
    let num = 0;
    if (!n) return num;
    if (n % 2 === 0) {
      num = (Math.floor(n / 2) - 1) * 5 + (75 * n) / 10;
    } else {
      num = Math.floor(n / 2) * 5 + (75 * n) / 10;
    }
    return num;
  }

  toggleTitle = () => {
    this.setState({ openTitle: !this.state.openTitle });
  };

  playDom = () => {
    const { preViewProps, activeLessonIndex } = this.state;

    // 资源预览，不需要显示打点功能
    return (
      <ResourceViewCom
        key={activeLessonIndex}
        mediaType={preViewProps.type}
        mediaAddress={preViewProps.url}
        playerCallBack={(media: any) => this.handleMedia(media)}
      />
    );

    // 点播课时且是mp4
    // return this.currentFileInfos.category === 1 && preViewProps.type === 'mp4' ? (
    //   <VideoMarkerPlayer
    //     defaultSilderOpen
    //     theme="#2683f5"
    //     videoUrl={preViewProps.url}
    //     markerData={markups}
    //     onSiderTrack={(data) => this.onSiderTrack(data)}
    //     onVideoTrack={(data) => this.onSiderTrack(data)}
    //     playerOptions={
    //       {
    //         events: {
    //           play: (player: any) => {
    //             this.xgPlayer = player;
    //             this.PlayTimeFn.startPlayTime({ ...this.ids });
    //             this.videoStatus !== 'topH5' && this.pausePlayer();
    //             this.videoStatus = 'topH5';
    //           },
    //           pause: (player: any) => {
    //             this.PlayTimeFn.stopPlayTime();
    //           },
    //           ended: (player: any) => {
    //             player.exitFullscreen();
    //           },
    //           timeupdate: (player: any) => {
    //             this.PlayTimeFn.getStartAndEnd(player.currentTime, player.duration, this.isTurnTo);
    //             this.isTurnTo = false;
    //           },
    //           ratechange: (player: any) => {
    //             this.PlayTimeFn.changePlayRate(player.playbackRate);
    //           },
    //         },
    //         xgplayerOptions: {
    //           autoplayMuted: false,
    //           autoplay: true,
    //         },
    //       } as any
    //     }
    //   />
    // ) : (
    //   <ResourceViewCom
    //     key={activeLessonIndex}
    //     mediaType={preViewProps.type}
    //     mediaAddress={preViewProps.url}
    //     playerCallBack={(media: any) => this.handleMedia(media)}
    //   />
    // );
  };

  onExpand = () => {
    this.setState({
      showResourceList: !this.state.showResourceList,
    });
  };

  render() {
    const {
      noSupport,
      videoHeight,
      showPreview,
      preViewProps,
      activeLessonIndex,
      resourceInfo,
      showResourceList,
    } = this.state;
    // const { hiddenLabel } = this.props;

    const { centerResources = [] } = resourceInfo;
    const { videoResourceType } = this.searchParams;

    // const tags = hideSubjectTag(lessonInfo.grades || [], lessonInfo.labels);

    return (
      <div className="vod-page" onContextMenu={(e: any) => e.preventDefault()}>
        <div className="vod-page-header">
          <div className="page-header-title">{resourceInfo.name}</div>
        </div>
        <Row className="flex">
          <Col style={{ height: videoHeight + 48 }} className="vod-page-content-left middle">
            <div ref={(topRef) => (this.topRef = topRef)} className="wrapper-player" />

            {showPreview ? (
              <div className="preview-wrap">
                {noSupport ? (
                  <div className="errorWrap">
                    <MyIcon type="iconpreview" className="errorIcon" />
                    <div className="errorText">暂不支持预览</div>
                  </div>
                ) : (
                  preViewProps.url && !preViewProps.playId && this.playDom()
                  // 上面播放器
                )}
              </div>
            ) : (
              ''
            )}
          </Col>

          <Col
            style={{ height: videoHeight, width: showResourceList ? 320 : 0 }}
            className="vod-page-content-right right"
          >
            <div className="vod-page-expand-btn" onClick={this.onExpand}>
              {!showResourceList ? <Icon type="double-left" /> : <Icon type="double-right" />}
              资源列表
            </div>
            <div className="vod-page-content-right-info">
              {centerResources.length > 0 ? (
                <div className="vod-page-content-right-item lesson-name">
                  <div className="item-title">
                    {videoResourceTypes.find((item) => item.value === videoResourceType)?.name}
                  </div>
                  {centerResources.map((item: NormalObj, index: number) => {
                    const isVideo = item.extension.toLowerCase() === 'mp4';
                    const attachmentItem = (
                      <ResourceAttachmentItem
                        data={item}
                        key={`${item.fileId}-${index}`}
                        index={index}
                        active={activeLessonIndex}
                        onClick={this.previewClick.bind(this, item, index)}
                        isVideo={isVideo}
                      />
                    );
                    if (isVideo) {
                      return (
                        <div key={`${item.fileId}-${index}`} className="item-text text">
                          {attachmentItem}
                        </div>
                      );
                    }
                    return attachmentItem;
                  })}
                </div>
              ) : (
                ''
              )}
            </div>
          </Col>
        </Row>
        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state: any) => ({
  ...state.Vod,
  ...state.Course,
  lessonList: state.CourseDetail.list,
  functionConfig: { ...state.DynamicControl.functionConfig },
});
export default Form.create<P>()(
  connect(mapStateTopProps, mergeProps)(withHiddenLabel(Vod, { columnIdFieldName: 'columnId' })),
);
